/**
 * Quiz Results Page: Performance Optimization
 * Code splitting, lazy loading, image optimization, Core Web Vitals
 */

(function() {
  'use strict';

  /**
   * Lazy load images with intersection observer
   */
  function initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              img.classList.add('veluna-image-loaded');
              observer.unobserve(img);
            }
          }
        });
      }, {
        rootMargin: '50px'
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }

  /**
   * Optimize images (convert to WebP if supported)
   */
  function optimizeImages() {
    const images = document.querySelectorAll('img[src]');
    images.forEach(img => {
      // Add loading="lazy" if not present
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      // Add decoding="async" for performance
      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }

      // Ensure proper sizing to prevent layout shift
      if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
        img.addEventListener('load', function() {
          if (!this.hasAttribute('width')) {
            this.setAttribute('width', this.naturalWidth);
            this.setAttribute('height', this.naturalHeight);
          }
        });
      }
    });
  }

  /**
   * Defer non-critical JavaScript
   */
  function deferNonCriticalJS() {
    // Mark scripts as defer if not already
    const scripts = document.querySelectorAll('script[src]:not([defer]):not([async])');
    scripts.forEach(script => {
      if (!script.src.includes('veluna-quiz-results') && !script.src.includes('veluna-luna')) {
        script.setAttribute('defer', '');
      }
    });
  }

  /**
   * Preload critical resources
   */
  function preloadCriticalResources() {
    // Preload critical CSS (if not already loaded)
    const criticalCSS = document.querySelector('link[rel="stylesheet"][href*="base.css"]');
    if (criticalCSS && !criticalCSS.hasAttribute('rel')) {
      const preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'style';
      preload.href = criticalCSS.href;
      document.head.appendChild(preload);
    }
  }

  /**
   * Track Core Web Vitals
   */
  function trackWebVitals() {
    // Largest Contentful Paint (LCP)
    if ('PerformanceObserver' in window) {
      try {
        const lcpObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const lastEntry = entries[entries.length - 1];
          
          if (window.VelunaQuizResultsCart && window.VelunaQuizResultsCart.trackEvent) {
            window.VelunaQuizResultsCart.trackEvent('web_vital_lcp', {
              value: Math.round(lastEntry.renderTime || lastEntry.loadTime),
              metric: 'LCP'
            });
          }
        });
        lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
      } catch (e) {
        console.warn('LCP tracking not supported:', e);
      }

      // First Input Delay (FID)
      try {
        const fidObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach(entry => {
            if (window.VelunaQuizResultsCart && window.VelunaQuizResultsCart.trackEvent) {
              window.VelunaQuizResultsCart.trackEvent('web_vital_fid', {
                value: Math.round(entry.processingStart - entry.startTime),
                metric: 'FID'
              });
            }
          });
        });
        fidObserver.observe({ entryTypes: ['first-input'] });
      } catch (e) {
        console.warn('FID tracking not supported:', e);
      }

      // Cumulative Layout Shift (CLS)
      let clsValue = 0;
      try {
        const clsObserver = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          entries.forEach(entry => {
            if (!entry.hadRecentInput) {
              clsValue += entry.value;
            }
          });

          if (window.VelunaQuizResultsCart && window.VelunaQuizResultsCart.trackEvent) {
            window.VelunaQuizResultsCart.trackEvent('web_vital_cls', {
              value: Math.round(clsValue * 1000) / 1000,
              metric: 'CLS'
            });
          }
        });
        clsObserver.observe({ entryTypes: ['layout-shift'] });
      } catch (e) {
        console.warn('CLS tracking not supported:', e);
      }
    }
  }

  /**
   * Initialize performance optimizations
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Initialize optimizations
    initLazyLoading();
    optimizeImages();
    deferNonCriticalJS();
    preloadCriticalResources();
    trackWebVitals();

    console.log('Quiz Results Performance: Optimizations initialized');
  }

  init();

  // Export
  if (typeof window !== 'undefined') {
    window.VelunaQuizResultsPerformance = {
      initLazyLoading,
      optimizeImages,
      trackWebVitals
    };
  }
})();









